<template lang="pug">
v-dialog(
  v-if="$conf.isVcht"
  v-model="dialog"
  :max-width="$vuetify.breakpoint.mdAndDown ? '90vw' : '70vw'"
)
  v-card
    v-card-title
      p.my-2 Уважаемые участники и организаторы!
    v-card-text
      p.my-2 Муниципальный этап завершается в ночь с 5 на 6 мая,
        |  в нем приняло участие более 20 000 команд. На этом задания олимпиады
        |  в формате отдельных тестовых вопросов закончились — дальше команды
        |  начнут работать в проектном формате и предлагать решение одной
        |  из предложенных проблем на выбор.
      p.my-2 6 мая участники смогут увидеть, сколько баллов
        |  набрала их команда на платформе. Для этого необходимо:
        ul
          li перейти в раздел «Результаты»
          li выбрать карточку с названием «Всероссийская олимпиада "Технологии успеха"
            |  в рамках Всероссийской Большой олимпиады
            |  "Искусство — Технологии — Спорт" — Муниципальный этап»
          li нажать на кнопку «Подробнее».
      p.my-2 Ниже появится панель с информацией о выполнении задания этапа — перейдите к
        |  шагу №3 «Результаты этапа». Там вы сможете посмотреть итоговые баллы,
        |  которые набрала команда. Проходной балл на следующий этап определяются
        |  по среднему баллу, который набрали команды в регионе.
      p.my-2 Посмотреть какой порог установился в вашем субъекте, можно по
        a.primary--text(
          href="https://docs.google.com/spreadsheets/d/1rnNQuE5iiiRC-SXPDfGEx5WyPx7yJG7M98r0iVjknqo/edit?usp=sharing"
          target="_blank"
        )  ссылке
        |  (данные появятся вечером 5 мая). В системе мы самостоятельно переведем команды,
        |  которые прошли на следующий этап до 15 мая включительно.
      p.my-2 Что делать уже сейчас, если вы видите, что по баллам прошли дальше?
        |  Выбирать задание для решения на региональном этапе. Список заданий
        |  и критерии оценки можно будет посмотреть по
        a.primary--text(
          href="https://docs.google.com/document/d/1OT_LfNZytB-kSjargcLNkD2T-18-lZTIc1HSdS9kjTg/edit?usp=sharing"
          target="_blank"
        )  ссылке
        |  , начиная с 6 мая.
      //- p.my-2 Продолжается регистрация организаций и участников на портале.
      //- p.my-2 Задания школьного этапа будут доступны с
      //-   b  7 марта.
      //- p.my-2 Чтобы зарегистрировать организацию или продолжить настройку
      //-   |  мероприятия (для региональных и муниципальных операторов) нажмите кнопку "Продолжить"
    v-card-actions
      v-btn(@click="closeAnnouncement" color="success").mr-4 Продолжить
      v-checkbox(v-model="notShow" label="Больше не показывать")
</template>

<script>
import targetIds from '@/assets/vcht/targetOrganizers';
import { ROLES } from '@/constants/roles';

const STORAGE_KEY = 'do_not_show_announcement';

export const ANNOUNCEMENT_TYPES = {
  TARGET: 1,
  ALL: 2,
};

export default {
  props: {
    type: {
      type: Number,
      default: ANNOUNCEMENT_TYPES.ALL,
    },
  },

  data() {
    return {
      dialog: false,
      notShow: false,
    };
  },

  mounted() {
    this.showDialog();
  },

  methods: {
    closeAnnouncement() {
      this.dialog = false;
      if (this.notShow) {
        window.localStorage.setItem(STORAGE_KEY, 'true');
      }
    },

    showDialog() {
      const localStorageKey = !window.localStorage.getItem(STORAGE_KEY);

      const isInTarget = this.type === ANNOUNCEMENT_TYPES.TARGET
        && this.$user.isAuthenticated
        && this.$user.hasRoles([ROLES.organization])
        && targetIds.includes(this.$user.data.organizer?.id);
      const isAll = this.type === ANNOUNCEMENT_TYPES.ALL;

      this.dialog = localStorageKey && (isInTarget || isAll);
    },
  },
};
</script>
